import { useQuery } from 'urql';
import { getMetaAdAccounts } from '../graphql';

export const useMetaAdAccounts = ({ clientId, pause }: { clientId: string; pause?: boolean }) => {
  const [{ data, fetching }] = useQuery({
    query: getMetaAdAccounts,
    variables: { clientId },
    pause,
  });

  return {
    data,
    fetching,
  };
};
